import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalCrearCredencialRdp = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        hostname: '',
        port: '',
        app_name: '',
        working_dir: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        // Validate required fields
        if (!formData.username || !formData.password || !formData.hostname || !formData.port) {
            alert('Por favor, complete todos los campos requeridos: Username, Password, Hostname y Puerto');
            return;
        }

        // Validate port range
        const portNum = parseInt(formData.port);
        if (isNaN(portNum) || portNum < 1 || portNum > 65535) {
            alert('El puerto debe ser un número entre 1 y 65535');
            return;
        }

        // Validate username length
        if (formData.username.length > 25) {
            alert('El username no puede exceder los 25 caracteres');
            return;
        }

        // Validate hostname length
        if (formData.hostname.length > 50) {
            alert('El hostname no puede exceder los 50 caracteres');
            return;
        }

        const dataToSend = {
            username: formData.username.trim(),
            password: formData.password,
            hostname: formData.hostname.trim(),
            port: portNum,
            app_name: formData.app_name ? formData.app_name.trim() : null,
            working_dir: formData.working_dir ? formData.working_dir.trim() : null,
        };

        onSave(dataToSend);
        setFormData({
            username: '',
            password: '',
            hostname: '',
            port: '',
            app_name: '',
            working_dir: '',
        }); // Reset
    };

    const handleClose = () => {
        setFormData({
            username: '',
            password: '',
            hostname: '',
            port: '',
            app_name: '',
            working_dir: '',
        });
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} size="lg">
            <ModalHeader toggle={handleClose}>Crear Credencial RDP</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="username">Username *</Label>
                        <Input
                            type="text"
                            name="username"
                            id="username"
                            value={formData.username}
                            onChange={handleChange}
                            maxLength={25}
                            placeholder="Usuario de RDP"
                        />
                        <small className="text-muted">Máximo 25 caracteres</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="password">Contraseña *</Label>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Contraseña de RDP"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="hostname">Hostname / IP *</Label>
                        <Input
                            type="text"
                            name="hostname"
                            id="hostname"
                            value={formData.hostname}
                            onChange={handleChange}
                            maxLength={50}
                            placeholder="192.168.1.100 o servidor.local"
                        />
                        <small className="text-muted">Máximo 50 caracteres</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="port">Puerto *</Label>
                        <Input
                            type="number"
                            name="port"
                            id="port"
                            value={formData.port}
                            onChange={handleChange}
                            min={1}
                            max={65535}
                            placeholder="3389"
                        />
                        <small className="text-muted">Puerto RDP por defecto: 3389</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="app_name">Nombre de Aplicación</Label>
                        <Input
                            type="text"
                            name="app_name"
                            id="app_name"
                            value={formData.app_name}
                            onChange={handleChange}
                            maxLength={255}
                            placeholder="Nombre opcional de la aplicación"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="working_dir">Directorio de Trabajo</Label>
                        <Input
                            type="text"
                            name="working_dir"
                            id="working_dir"
                            value={formData.working_dir}
                            onChange={handleChange}
                            maxLength={255}
                            placeholder="C:\Users\Usuario\Documents"
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={handleClose}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearCredencialRdp;
